<template>
  <base-modal ref="modal" @hiding="reset()">
    <base-card>
      <h3 class="tw-text-xl tw-font-thin">Add Tax Rate</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5 tw-mb-3">
        <base-text-field label="Name" v-model="name" required />
        <base-text-field label="Description" v-model="description" />
        <base-text-field class="tw-mt-6" label="Jurisdiction (describes the area the tax applies to)" v-model="jurisdiction" />
        <base-text-field class="tw-mt-6" label="Percentage" v-model="percentage" type="number" min="0" max="100" step="1" required>
          <template #postfix
            >%</template
          >
        </base-text-field>
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse">
        <base-button @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!isFormValid">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error class="tw-mt-3" id="add-tax-rate-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";
import { mapActions } from "vuex";

export default {
  name: "CreateTaxRate",
  components: {
    InlineError,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      name: null,
      description: null,
      jurisdiction: null,
      percentage: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    ...mapActions("businessActivation", { businessActivationInit: "init" }),
    reset() {
      this.name = null;
      this.jurisdiction = null;
      this.description = null;
      this.percentage = null;
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
      this.$refs.form.reset();
    },
    show() {
      this.$refs.modal.show();
      this.reset();
    },
    hide() {
      this.$refs.modal.hide();
      this.reset();
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;

      this.$axios
        .post(`/businesses/${this.businessId}/taxrates`, { name: this.name, description: this.description, jurisdiction: this.jurisdiction, percentage: this.percentage })
        .then(() => {
          this.$emit("created", {});
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Tax Rate Saved", message: this.name + " tax rate was saved successfully" });
          this.hide();
          this.businessActivationInit();
        })
        .catch((err) => {
          this.errorTitle = `Error creating tax rate`;
          this.errorMessage = "Sorry, we had trouble creating this tax rate. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
